export default __webpack_public_path__ + "static/truck_grey_house-55c16fc931c380bad9fb001f6b057f3d.jpg";